import React from 'react';
import {Button} from "@material-ui/core";

const SecondaryButton = ({children,onClick,style}) => 
{
    return <Button  onClick={onClick} style={style} variant="outlined" color="secondary">{children}</Button>
}

export default SecondaryButton
